export const getSessionUsername = (fallback = "admin") => {
  try {
    const savedUser = sessionStorage.getItem("user");
    if (savedUser) {
      const user = JSON.parse(savedUser);
      const userName = user?.UsrName || user?.UserName || user?.username;
      if (userName) return userName;
    }

    return (
      sessionStorage.getItem("UsrName") ||
      sessionStorage.getItem("username") ||
      fallback
    );
  } catch {
    return fallback;
  }
};
